import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import store from '../store'
Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
				PointColor1: store.state.PointColor1,
				PointColor2: store.state.PointColor2,
				PointColor3: store.state.PointColor3,
				PointColor4: store.state.PointColor4,
				PointColor5: store.state.PointColor5,
				PointColor6: store.state.PointColor6,
				PointColor7: store.state.PointColor7,
				PointColor8: store.state.PointColor8,
				PointColor9: store.state.PointColor9,
				PointColor10: store.state.PointColor10, // 래미안 컬러
				PointColor11: store.state.PointColor11, // 래미안 컬러
				primary: '#323153',
				MainColor1: '#F2A629',
				MainColor2: '#FB9C00',
				MainColor3: '#ffd999',
				// MainColor2: '',
				// MainColor4: '',
			},
		},
	},
	icons: {
		iconfont: 'mdi', // default - only for display purposes
	},
})
